export const light = {
    colors: {
        background: "#ffffff",
        home_bg: "#FAFAFA",
        color: "#000000",
        normal: "#919191",
        main: "#f4394f",
        primary: "#007bff",
        info: "#1890ff",
        success: "#52c41a",
        green: "#05C755",
        processing: "#1890ff",
        error: "#f5222d",
        highlight: "#f5222d",
        warning: "#faad14",
        dark: "rgb(51,51,51)",
        text: "#000000",
        textSecondary: "rgba(145, 145, 145)",
        borderBase: "hsv(0, 0, 85%)",
        borderSplit: "rgba(0, 0, 0, 0.05)",
        red: "red",
        danger: "#f5222d",
        dark_gray: "#f1f1f1",
        card: "#ffffff",
        cutter: "#4a515c",
        white: "white",
        black: "black",
    },
};
export const dark = {
    colors: {
        background: "#000000",
        home_bg: "#000000",
        color: "#fff",
        normal: "#f1f1f1",
        main: "#f4394f",
        primary: "#007bff",
        info: "#1890ff",
        success: "#52c41a",
        green: "#05C755",
        processing: "#1890ff",
        error: "#f5222d",
        highlight: "#f5222d",
        warning: "#faad14",
        dark: "rgb(51,51,51)",
        text: "#000000",
        textSecondary: "rgba(145, 145, 145)",
        borderBase: "hsv(0, 0, 85%)",
        borderSplit: "rgba(0, 0, 0, 0.05)",
        red: "red",
        danger: "#f5222d",
        dark_gray: "#464D53",
        card: "#303437",
        cutter: "#000",
        white: "white",
        black: "black",
    },
};
export const theme = {
    colors: {
        main: "#f4394f",
        primary: "#007bff",
        info: "#1890ff",
        color: "#000",
        success: "#52c41a",
        green: "#05C755",
        processing: "#1890ff",
        error: "#f5222d",
        highlight: "#f5222d",
        warning: "#faad14",
        normal: "#919191",
        background: "#f7f7f9",
        dark: "rgb(51,51,51)",
        text: "#000000",
        textSecondary: "rgba(145, 145, 145)",
        borderBase: "hsv(0, 0, 85%)",
        borderSplit: "rgba(0, 0, 0, 0.05)",
        red: "red",
        danger: "#f5222d",
        card: "#f1f1f1",
        cutter: "#000",
        home_bg: "#FAFAFA",
        white: "white",
        black: "black",
    },
    heights: {
        input: "48px",
        button: "49px",
    },
    borderRadius: {
        base: "4px",
        sm: "4px",
    },
    breakPoints: {
        breakSmall: "320px",
        breakMobile: "375px",
        breakMobileLarge: "414px",
        breakMobileMax: "480px",
        breakMobileMedium: "575px",
        breakTablet: "767px",
        breakOnlyMobile: "768px",
    },
    widths: {
        wide_650: "650px",
        wide_700: "700px",
        wide_900: "900px",
        wide_1110: "1110px",
    },
    family: {
        font: `"Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif,
        "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        code: `"Anonymous Pro", "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace`,
    },
    menu: {
        inlineTopLevelItemHeight: "36px",
        itemHeight: "36px",
    },
    header: {
        background: "#ffffff",
        height: "60px",
    },
    card: {
        paddingBase: "16px",
        paddingWider: "16px",
    },
};
